function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.87129 3.08316L3.89686 1.10873C3.7016 0.913471 3.7016 0.596888 3.89686 0.401626C4.09212 0.206364 4.4087 0.206364 4.60397 0.401626L7.378 3.17566C7.6033 3.40096 7.6033 3.76625 7.378 3.99155L4.60397 6.76559C4.4087 6.96085 4.09212 6.96085 3.89686 6.76559C3.7016 6.57032 3.7016 6.25374 3.89686 6.05848L5.87218 4.08316L0.964926 4.08357C0.688783 4.08359 0.464907 3.85975 0.464885 3.58361C0.464862 3.30746 0.688701 3.08359 0.964843 3.08357L5.87129 3.08316Z"
});

function SvgIconArrowright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowright);
export default __webpack_public_path__ + "static/media/icon_arrowright.8daa321b.svg";
export { ForwardRef as ReactComponent };